import React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

export const Login: React.FC = () => {
  const { keycloak } = useKeycloak();

  // Redirect if already authenticated
  if (keycloak?.authenticated) {
    window.location.href = '/map';
    return null;
  }

  const handleKeycloakLogin = () => {
    if (keycloak) {
      keycloak.login();
    } else {
      toast.error('Authentication service is not available');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 bg-[#171717] rounded-full flex items-center justify-center">
            <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-[#171717]">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-[#555]">
            Welcome back to Finderz - your project management solution
          </p>
        </div>

        <div className="space-y-6">
          <button
            type="button"
            onClick={handleKeycloakLogin}
            className="w-full inline-flex justify-center items-center py-3 px-5 border border-transparent text-base font-medium rounded-md text-white bg-[#171717] hover:bg-[#333] focus:outline-none focus:ring-0 transition duration-150 ease-in-out shadow-[0_4px_12px_rgba(0,0,0,0.08)]"
          >
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            Continue with Keycloak
          </button>

          <div className="text-center">
            <p className="text-sm text-[#555]">
              Don't have an account?{' '}
              <Link to="/register" className="font-medium text-[#171717] hover:text-blue-500 transition duration-150 ease-in-out">
                Create one here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}; 